import { TimeForm } from 'components/common/form-item/TimeForm';
import { PaymentCardInfo } from 'components/common/PaymentCardInfo';
import { TotalCardInfo } from 'components/common/TotalCardInfo';
import { CommissionIcon, TotalRevenueIcon } from 'assets/images';
import { useQuery } from 'react-query';
import { QUERY_KEY } from '../../constant';
import { getDataDashboard } from '../../services/dashboard';
import { HeaderCommon } from '../../components/header';
import {
  Area,
  AreaChart,
  CartesianGrid,
  Cell,
  Label,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import Scrollbars from 'react-custom-scrollbars';
import { TableBusiness } from './TableBusiness';
import { MyProductCard } from './MyProductCard';
import { useContext, useMemo, useState } from 'react';
import { get, isEmpty, sumBy } from 'lodash';
import { getLabelItemType } from '../../utils/utils';
import { DailyCMSIcon, PercentCMSIcon, TopCMSIcon } from '../../assets/images/dashboard';
import AuthContext from '../../context/AuthProvider';
import { ButtonGradient } from '../../components/common/button/ButtonGradient';
import { subscriptionFeeIcon } from '../../assets/images/products';
import { endOfToday, format, parse, startOfToday, subDays } from 'date-fns';
import toast from 'react-hot-toast';
import useCheckDeviceMobi from 'hooks/useCheckDeviceMobi';
import { AccountAuthen } from 'components/common/AccountAuthen';
import { ZaloChat } from 'components/common/zalo';
import configs from 'configs/config';
import Cookies from 'js-cookie';

const COLORS_PIE = [
  { start: '#F15836', stop: '#FF924F' },
  { start: '#FFB01F', stop: '#FFCF45' },
  { start: '#DB457B', stop: '#C61B59' },
];

export const Dashboard = () => {
  const isMobile = useCheckDeviceMobi();
  const [isShowNotification, setIsShowNotification] = useState<boolean>(false);

  const [startDay, setStartDay] = useState<Date | null>(subDays(startOfToday(), 6));
  const [endDay, setEndDay] = useState<Date | null>(endOfToday());
  const { userLogin } = useContext(AuthContext);
  const { data } = useQuery(
    [QUERY_KEY.DASHBOARD, startDay, endDay],
    () =>
      getDataDashboard({
        fromDate: startDay ? format(startDay, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx") : '',
        toDate: endDay ? format(endDay, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx") : '',
        username: 'admin',
      }),
    {
      enabled: !!Cookies.get('token'),
      retry: 0,
      refetchOnWindowFocus: false,
    }
  );

  const dataAccount = useMemo(() => {
    if (!data?.data?.data?.data) {
      return null;
    }
    const accBalance = data.data.data.data.accBalance;
    const totalAmount = data.data.data.data.totalAmount;
    const totalAmountPercent = data.data.data.data.totalAmountPercent;
    const childNum = data.data.data.data.childNum;
    const cmsPercent = data.data.data.data.cmsPercent.map((item: any) => {
      return {
        name: item.itemType,
        value: item.totalOfItem,
      };
    });
    const cmsTop = data.data.data.data.cmsTop;
    const dailyCms = data.data.data.data.dailyCms.map((item: any) => ({
      ...item,
      day: format(parse(item.day, 'dd/MM/yyyy', new Date()), 'dd.MM.yyyy'),
    }));
    const cmsCtv = data.data.data.data.cmsCtv;
    const cmsBussiness = data.data.data.data.cmsBussiness;
    const cmsBussinessPercent = data.data.data.data.cmsBussinessPercent;
    const top5CreateByMe = data.data.data.data.top5CreateByMe;
    const maxTotalInDay = Math.max.apply(
      null,
      dailyCms.map((x: any) => x.totalInDay)
    );

    return {
      accBalance,
      totalAmount,
      totalAmountPercent,
      childNum,
      cmsPercent,
      cmsTop,
      dailyCms,
      cmsCtv,
      cmsBussiness,
      top5CreateByMe,
      cmsBussinessPercent,
      leftEchart: maxTotalInDay.toString().length - 5 > 0 ? 10 * (maxTotalInDay.toString().length - 5) : 0,
    };
  }, [data]);

  return (
    <>
      {isMobile ? (
        <div className={'h-fit w-full'}>
          <div className={'md:mr-7'}>
            <div className={'flex flex-col md:hidden'}>
              <div className={"h-[272px] w-full bg-[url('assets/images/dashboard/dashboard-bg-mobi.svg')] px-4 pt-4"}>
                <p className={'mt-[60px] text-[22px] font-extrabold leading-[26px] text-white'}>
                  Xin chào,
                  {userLogin && <span> {userLogin.accountName}</span>}
                </p>
                <p className={'mt-1 text-sm font-medium text-[#FFE8AA]'}>
                  Chào mừng bạn đến với hệ thống tiếp thị liên kết Shop360!
                </p>
                <div className={'mt-4 h-fit w-full'}>
                  <TimeForm startDay={startDay} setStartDay={setStartDay} endDay={endDay} setEndDay={setEndDay} />
                </div>
                <p className={'mb-3 mt-6 text-[22px] font-extrabold leading-[26px] text-white'}>Tổng quan</p>
                <div className={'flex flex-row space-x-2'}>
                  <TotalCardInfo
                    iconUrl={TotalRevenueIcon}
                    data={dataAccount?.totalAmount}
                    label={'Tổng doanh thu'}
                    value={dataAccount?.totalAmountPercent}
                  />
                  <TotalCardInfo
                    iconUrl={CommissionIcon}
                    data={dataAccount?.cmsBussiness}
                    label={'Hoa hồng kinh doanh'}
                    value={dataAccount?.cmsBussinessPercent}
                  />
                </div>
              </div>
              <div className={'mt-[160px] flex h-[352px] w-full flex-col px-4'}>
                <h2 className={'mb-2 text-[18px] font-bold text-[#404040]'}>Biểu đồ hoa hồng</h2>
                <div className={'h-full w-full rounded-[15px] bg-white p-2 shadow-base'}>
                  {!isEmpty(dataAccount?.dailyCms) ? (
                    <ResponsiveContainer width="100%" height="100%">
                      <AreaChart
                        margin={{ left: dataAccount?.leftEchart }}
                        width={window.innerWidth - 40}
                        height={250}
                        data={dataAccount?.dailyCms}
                      >
                        <defs>
                          <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#FF924F" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="#F15836" stopOpacity={0} />
                          </linearGradient>
                        </defs>
                        <XAxis dataKey="day" />
                        <YAxis />
                        <CartesianGrid strokeDasharray="3 3" />
                        <Tooltip content={<CustomTooltip />} />
                        <Area
                          type="monotone"
                          dataKey="totalInDay"
                          stroke="#FF924F"
                          fillOpacity={1}
                          fill="url(#colorPv)"
                        />
                      </AreaChart>
                    </ResponsiveContainer>
                  ) : (
                    <div className={'flex h-full w-full flex-col items-center justify-center space-y-2'}>
                      <img src={DailyCMSIcon} alt="DailyCMSIcon" className={'h-[165px] w-[212px]'} />
                      <span className={'text-sm text-[#818181]'}>Chưa có dữ liệu</span>
                    </div>
                  )}
                </div>
              </div>
              <div className={'mt-8 flex h-[352px] w-full flex-col px-4'}>
                <h2 className={'mb-2 text-[18px] font-bold text-[#404040]'}>Tỷ trọng hoa hồng</h2>
                <div className={'h-[300px] w-full rounded-[15px] bg-white p-8 text-center shadow-base'}>
                  {!isEmpty(dataAccount?.cmsPercent) ? (
                    <div className={'flex h-full w-full flex-col items-center justify-center space-y-4'}>
                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart width={800} height={400} onMouseEnter={() => {}}>
                          <defs>
                            {dataAccount?.cmsPercent.map((entry: any, index: number) => (
                              <linearGradient id={`myGradient${index}`} key={`myGradient${index}`}>
                                <stop offset="0%" stopColor={COLORS_PIE[index % COLORS_PIE.length].start} />
                                <stop offset="88%" stopColor={COLORS_PIE[index % COLORS_PIE.length].stop} />
                              </linearGradient>
                            ))}
                          </defs>
                          <Pie
                            data={dataAccount?.cmsPercent}
                            innerRadius={'80%'}
                            outerRadius={'100%'}
                            fill="#8884d8"
                            paddingAngle={5}
                            dataKey="value"
                          >
                            {dataAccount?.cmsPercent.map((entry: any, index: number) => (
                              <Cell key={`cell-${index}`} fill={`url(#myGradient${index})`} />
                            ))}
                            <Label
                              width={30}
                              position="center"
                              content={
                                <CustomLabel
                                  value={
                                    sumBy(dataAccount?.cmsPercent, (item: any) => item.value)?.toLocaleString('vi') || 0
                                  }
                                />
                              }
                            ></Label>
                          </Pie>
                        </PieChart>
                      </ResponsiveContainer>
                      <div
                        className={'grid gap-8'}
                        style={{
                          gridTemplateColumns: `repeat(${dataAccount?.cmsPercent?.length || 1}, minmax(0, 1fr))`,
                        }}
                      >
                        {dataAccount?.cmsPercent.map((entry: any, index: number) => (
                          <div key={index} className={'flex flex-row space-x-2'}>
                            <div
                              className={`h-[18px] w-[18px] rounded-t-[5px] rounded-bl-[5px] bg-gradient-to-r from-[${
                                COLORS_PIE[index % COLORS_PIE.length].start
                              }] to-[${COLORS_PIE[index % COLORS_PIE.length].stop}]`}
                            ></div>
                            <span>{getLabelItemType(entry.name)}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className={'flex h-full w-full flex-col items-center justify-center space-y-2'}>
                      <img src={PercentCMSIcon} alt="PercentCMSIcon" className={'h-[165px] w-[212px]'} />
                      <span className={'text-sm text-[#818181]'}>Chưa có dữ liệu</span>
                    </div>
                  )}
                </div>
              </div>
              <div className={'mt-8 flex h-fit w-full flex-col px-4'}>
                <h2 className={'mb-2 text-[18px] font-bold text-[#404040]'}>Top 5 sản phẩm của tôi</h2>
                <div className={'flex flex-col space-y-[1px] rounded-l-[15px] rounded-tr-[15px] bg-white shadow-base'}>
                  {dataAccount && dataAccount.top5CreateByMe?.length > 0 ? (
                    dataAccount.top5CreateByMe.map((item: any, index: number) => (
                      <MyProductCard item={item} key={index} />
                    ))
                  ) : (
                    <div className={'flex h-fit w-full flex-col items-center justify-center space-y-2  py-10'}>
                      <img src={TopCMSIcon} alt="TopCMSIcon" className={'h-[165px] w-[212px]'} />
                      <span className={'text-sm text-[#818181]'}>Chưa có dữ liệu</span>
                    </div>
                  )}
                </div>
              </div>
              <div className={'mt-8 flex min-h-[361px] w-full flex-col px-4'}>
                <h2 className={'mb-2 text-[18px] font-bold text-[#404040]'}>Top sản phẩm kinh doanh trên nền tảng</h2>
                <div className={'flex flex-col space-y-2'}>
                  {dataAccount?.cmsTop.map((item: any, index: number) => {
                    return (
                      <div
                        className={
                          'flex h-[115px] w-full flex-col space-y-2 rounded-t-[16px] rounded-bl-[16px] bg-white p-1 shadow-base'
                        }
                        key={index}
                      >
                        <div className={'flex h-full w-full flex-row justify-between'}>
                          <div className={'flex flex-row items-center justify-between space-x-0.5'}>
                            <img
                              src={subscriptionFeeIcon}
                              alt={'subscriptionFeeIcon'}
                              className={'h-[35px] w-[35px] object-none'}
                            />
                            <div className={'flex flex-col'}>
                              <span className={'text-sm font-bold text-[#404040]'}>{getName(item.itemType)}</span>
                              <span className={'text-[12px] font-normal text-[#818181]'}>{item.itemName}</span>
                            </div>
                          </div>
                          <div className={'flex flex-col items-end justify-center'}>
                            <div className={'flex flex-row items-center space-x-2 text-sm font-bold text-[#F15836]'}>
                              <svg
                                width="19"
                                height="19"
                                viewBox="0 0 19 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.87891 2.89258C7.20831 2.89495 6.56585 3.1624 6.09166 3.63658C5.61747 4.11077 5.35003 4.75323 5.34766 5.42383C5.34766 5.87383 5.47534 6.29177 5.68178 6.65458C4.66872 7.24745 3.87559 8.08895 3.44922 9.08008H3.37891C3.34174 9.08092 3.30479 9.07423 3.27028 9.06039C3.23578 9.04656 3.20444 9.02587 3.17815 8.99959C3.15186 8.9733 3.13118 8.94196 3.11734 8.90745C3.10351 8.87295 3.09681 8.83599 3.09766 8.79883C3.09766 8.69983 3.14828 8.62108 3.22084 8.57045L2.57003 7.65639C2.38573 7.78455 2.23515 7.95537 2.13114 8.1543C2.02712 8.35322 1.97275 8.57435 1.97266 8.79883C1.97266 9.4907 2.48903 10.0577 3.15053 10.1702C3.12184 10.3671 3.09766 10.5634 3.09766 10.7676C3.09766 12.1693 3.84241 13.3843 4.92578 14.2832C4.78966 14.8457 4.85772 15.4453 5.29478 15.883C5.61746 16.2029 6.05344 16.3823 6.50781 16.3823C6.96219 16.3823 7.39817 16.2029 7.72084 15.883L7.93178 15.672C8.37109 15.753 8.81266 15.8301 9.28516 15.8301C9.75766 15.8301 10.1992 15.753 10.6385 15.672L10.8495 15.883C11.1721 16.2029 11.6081 16.3823 12.0625 16.3823C12.5169 16.3823 12.9529 16.2029 13.2755 15.883C13.7036 15.4543 13.7677 14.8721 13.6445 14.3181C14.0956 13.9517 14.4818 13.5121 14.787 13.0176H16.0352V8.51758H14.7521C14.5479 8.18604 14.3059 7.87931 14.031 7.60352L14.3477 5.86314V5.14258H13.7852C13.7852 5.14258 12.434 5.16508 11.2888 6.02177C10.9881 5.93502 10.683 5.86442 10.3747 5.81027C10.3972 5.68539 10.4102 5.55545 10.4102 5.42383C10.4102 4.03277 9.26997 2.89258 7.87891 2.89258ZM7.87891 4.01758C8.66078 4.01758 9.28516 4.64195 9.28516 5.42383C9.28516 5.52058 9.26772 5.61283 9.24972 5.70508C8.34241 5.70958 7.48572 5.88508 6.70159 6.17983C6.55224 5.956 6.47257 5.69292 6.47266 5.42383C6.47266 4.64195 7.09703 4.01758 7.87891 4.01758ZM13.082 6.37333C13.091 6.37108 13.091 6.37502 13.0995 6.37333L12.8885 7.65583L12.8362 7.95508L13.082 8.16602C13.4576 8.49129 13.7678 8.88512 13.9961 9.32645L14.1542 9.64258H14.9102V11.8926H14.1542L13.9961 12.2093C13.7216 12.7515 13.2885 13.2285 12.7305 13.6324L12.326 13.9316L12.5724 14.389C12.7063 14.6151 12.6821 14.8941 12.4841 15.0921C12.4307 15.1477 12.3666 15.192 12.2956 15.2223C12.2247 15.2526 12.1484 15.2682 12.0712 15.2682C11.9941 15.2682 11.9177 15.2526 11.8468 15.2223C11.7758 15.192 11.7117 15.1477 11.6583 15.0921L11.2539 14.6871L11.0255 14.4767L10.7263 14.547C10.2695 14.6522 9.78409 14.7051 9.28516 14.7051C8.80018 14.7068 8.31655 14.6538 7.84347 14.547L7.54534 14.4767L7.31641 14.6876L6.91197 15.0915C6.85857 15.1473 6.79443 15.1916 6.72343 15.222C6.65242 15.2523 6.57602 15.2679 6.49881 15.2679C6.42161 15.2679 6.3452 15.2523 6.2742 15.222C6.20319 15.1916 6.13906 15.1473 6.08566 15.0915C5.99308 15.0019 5.93391 14.8833 5.91795 14.7554C5.90199 14.6275 5.9302 14.498 5.99791 14.3884L6.24428 13.9316L5.83984 13.633C4.82228 12.8938 4.22266 11.8858 4.22266 10.7676C4.22266 8.6627 6.42203 6.83008 9.28516 6.83008C9.97703 6.83008 10.6363 6.93358 11.2365 7.12877L11.5352 7.23452L11.7815 7.02358C12.1832 6.66527 12.6798 6.47233 13.082 6.37333ZM12.6602 9.64258C12.3508 9.64258 12.0977 9.8957 12.0977 10.2051C12.0977 10.5145 12.3508 10.7676 12.6602 10.7676C12.9695 10.7676 13.2227 10.5145 13.2227 10.2051C13.2227 9.8957 12.9695 9.64258 12.6602 9.64258Z"
                                  fill="#F15836"
                                />
                              </svg>
                              {`${item.amount ? (+item.amount).toLocaleString('vi') : 0} VNĐ`}
                            </div>
                            <div
                              className={'flex flex-row items-center space-x-2 text-[10px] font-normal text-[#818181]'}
                            >
                              <svg
                                width="10"
                                height="10"
                                viewBox="0 0 10 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.55859 3.51758H3.56234M3.55859 2.01758H5.43359C5.62559 2.01758 5.81759 2.0907 5.96384 2.23733L8.58884 4.86233C8.72945 5.00297 8.80843 5.1937 8.80843 5.39258C8.80843 5.59145 8.72945 5.78218 8.58884 5.92283L5.96384 8.54783C5.8232 8.68843 5.63247 8.76742 5.43359 8.76742C5.23472 8.76742 5.04399 8.68843 4.90334 8.54783L2.27834 5.92283C2.2086 5.85327 2.15328 5.77063 2.11556 5.67963C2.07785 5.58863 2.05849 5.49108 2.05859 5.39258V3.51758C2.05859 3.11975 2.21663 2.73822 2.49793 2.45692C2.77924 2.17561 3.16077 2.01758 3.55859 2.01758Z"
                                  stroke="#818181"
                                  strokeWidth="0.75"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              {`${item.shareValue ? item.shareValue.toLocaleString('vi') : 0} VNĐ`}
                            </div>
                          </div>
                        </div>
                        <ButtonGradient
                          className={'h-[32px] w-full !rounded-t-[8px] !rounded-bl-[8px]'}
                          background={'bg-white !rounded-t-[6px] !rounded-bl-[6px]'}
                          onClick={() => {
                            if (userLogin?.statusVerify !== 1) {
                              setIsShowNotification(true);
                              return;
                            }
                            if (item?.agent === 3) {
                              navigator?.clipboard?.writeText(
                                configs.API_DOMAIN +
                                  `/product/goi-cuoc-uu-dai/${encodeURIComponent(item.itemName)}?packType=vinaphone`
                              );
                            } else {
                              navigator?.clipboard?.writeText(item.link);
                            }
                            toast.success('Sao chép link thành công!');
                          }}
                        >
                          <span className={'whitespace-nowrap text-sm font-bold leading-[18px] text-[#F15836]'}>
                            Lấy link
                          </span>
                        </ButtonGradient>
                      </div>
                    );
                  })}
                </div>
              </div>
              {isShowNotification && <AccountAuthen setIsShowNotification={setIsShowNotification} />}
              <div className={'mb-6 mt-8 h-fit w-full px-4'}>
                <h2 className={'mb-2 text-[22px] font-extrabold text-[#404040]'}>Tài khoản</h2>
                <PaymentCardInfo onClick={() => {}} isLeftFuncRequest accBalance={dataAccount?.accBalance} />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={'h-full w-full bg-[#F8F8F8] md:rounded-[20px] md:p-6 md:!pr-0'}>
          <HeaderCommon />
          <div className={'hidden h-full w-full md:block md:h-[calc(100%-90px)]'}>
            <Scrollbars className={'h-full w-full'}>
              <div className={'md:mr-7'}>
                <div className={'hidden grid-cols-3 gap-6 md:grid lg:grid-cols-3'}>
                  <div className={'col-span-3 grid h-fit grid-cols-3 gap-4'}>
                    <div className="md:col-span-3 lg:col-span-2">
                      <div className={'h-fit w-full'}>
                        <div className={'mb-6 flex flex-row justify-between'}>
                          <h2 className={'text-[22px] font-extrabold text-[#404040]'}>Tổng quan</h2>
                          <div className={'min-w-[266px]'}>
                            <TimeForm
                              startDay={startDay}
                              setStartDay={setStartDay}
                              endDay={endDay}
                              setEndDay={setEndDay}
                              isDisabledSelectToday={true}
                            />
                          </div>
                        </div>
                        <div className={'grid grid-cols-1 gap-4 md:grid-cols-2'}>
                          <TotalCardInfo
                            iconUrl={TotalRevenueIcon}
                            data={dataAccount?.totalAmount}
                            label={'Tổng doanh thu'}
                            value={dataAccount?.totalAmountPercent}
                          />
                          <TotalCardInfo
                            iconUrl={CommissionIcon}
                            data={dataAccount?.cmsBussiness}
                            label={'Hoa hồng kinh doanh'}
                            value={dataAccount?.cmsBussinessPercent}
                          />
                        </div>
                      </div>
                    </div>

                    {/* tai khoan */}
                    <div className={'h-fit w-full md:col-span-3 lg:col-span-1'}>
                      <h2 className={'mb-6 text-[22px] font-extrabold text-[#404040]'}>Tài khoản</h2>
                      <PaymentCardInfo onClick={() => {}} isLeftFuncRequest accBalance={dataAccount?.accBalance} />
                    </div>
                  </div>

                  {/* <div className={'lg:col-span-1 grid  h-fit lg:grid-cols-1 md:grid-cols-2 md:col-span-2 gap-4'}> */}
                  <div className={'col-span-3 grid h-fit grid-cols-3  gap-4'}>
                    <div className="md:col-span-3 xl:col-span-2">
                      {/* bieu do */}
                      <div className={'flex h-[352px] w-full flex-col'}>
                        <h2 className={'mb-6 text-[22px] font-extrabold text-[#404040]'}>Biểu đồ hoa hồng</h2>
                        <div className={'h-full w-full rounded-[15px] bg-white p-2 shadow-base'}>
                          {!isEmpty(dataAccount?.dailyCms) ? (
                            <ResponsiveContainer width="100%" height="100%">
                              <AreaChart
                                margin={{ left: dataAccount?.leftEchart }}
                                width={730}
                                height={250}
                                data={dataAccount?.dailyCms?.reverse()}
                              >
                                <defs>
                                  <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor="#FF924F" stopOpacity={0.8} />
                                    <stop offset="95%" stopColor="#F15836" stopOpacity={0} />
                                  </linearGradient>
                                </defs>
                                <XAxis dataKey="day" />
                                <YAxis />
                                <CartesianGrid strokeDasharray="3 3" stroke={'#818181'} />
                                <Tooltip content={<CustomTooltip />} />
                                <Area
                                  type="monotone"
                                  dataKey="totalInDay"
                                  stroke="#F15836"
                                  fillOpacity={1}
                                  fill="url(#colorPv)"
                                />
                              </AreaChart>
                            </ResponsiveContainer>
                          ) : (
                            <div className={'flex h-full w-full flex-col items-center justify-center space-y-2'}>
                              <img src={DailyCMSIcon} alt="DailyCMSIcon" className={'h-[165px] w-[212px]'} />
                              <span className={'text-sm text-[#818181]'}>Chưa có dữ liệu</span>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* top san pham */}
                      <div className={'mt-[1rem] flex min-h-[361px] w-full flex-col'}>
                        <h2 className={'mb-6 text-[22px] font-extrabold text-[#404040]'}>
                          Top sản phẩm kinh doanh trên nền tảng
                        </h2>
                        <TableBusiness record={dataAccount?.cmsTop} />
                      </div>
                    </div>

                    <div className="col-span-1 md:col-span-3 lg:grid lg:grid-cols-2 lg:gap-4 xl:col-span-1 xl:block">
                      <div className={'flex h-[352px] w-full flex-col '}>
                        <h2 className={'mb-6 text-[22px] font-extrabold text-[#404040]'}>Tỷ trọng hoa hồng</h2>
                        <div className={'h-[300px] w-full rounded-[15px] bg-white p-8 text-center shadow-base'}>
                          {!isEmpty(dataAccount?.cmsPercent) ? (
                            <div className={'flex h-full w-full flex-col items-center justify-center space-y-4'}>
                              <ResponsiveContainer width="100%" height="100%">
                                <PieChart width={800} height={400} onMouseEnter={() => {}}>
                                  <defs>
                                    {dataAccount?.cmsPercent.map((entry: any, index: number) => (
                                      <linearGradient id={`myGradient${index}`} key={`myGradient${index}`}>
                                        <stop offset="0%" stopColor={COLORS_PIE[index % COLORS_PIE.length].start} />
                                        <stop offset="88%" stopColor={COLORS_PIE[index % COLORS_PIE.length].stop} />
                                      </linearGradient>
                                    ))}
                                  </defs>
                                  <Pie
                                    data={dataAccount?.cmsPercent}
                                    innerRadius={'80%'}
                                    outerRadius={'100%'}
                                    fill="#8884d8"
                                    paddingAngle={5}
                                    dataKey="value"
                                  >
                                    {dataAccount?.cmsPercent.map((entry: any, index: number) => (
                                      <Cell key={`cell-${index}`} fill={`url(#myGradient${index})`} />
                                    ))}
                                    <Label
                                      width={30}
                                      position="center"
                                      content={
                                        <CustomLabel
                                          value={
                                            sumBy(dataAccount?.cmsPercent, (item: any) => item.value)?.toLocaleString(
                                              'vi'
                                            ) || 0
                                          }
                                        />
                                      }
                                    ></Label>
                                  </Pie>
                                </PieChart>
                              </ResponsiveContainer>
                              <div
                                className={'grid justify-center gap-2'}
                                style={{
                                  gridTemplateColumns: `repeat(${
                                    dataAccount?.cmsPercent?.length || 0
                                  }, minmax(0, 1fr))`,
                                }}
                              >
                                {dataAccount?.cmsPercent.map((entry: any, index: number) => (
                                  <div key={index} className={'flex flex-row space-x-1'}>
                                    <div
                                      className={`h-[18px] w-[18px] rounded-t-[5px] rounded-bl-[5px] bg-gradient-to-r from-[${
                                        COLORS_PIE[index % COLORS_PIE.length].start
                                      }] to-[${COLORS_PIE[index % COLORS_PIE.length].stop}]`}
                                    ></div>
                                    <span>{getLabelItemType(entry.name)}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ) : (
                            <div className={'flex h-full w-full flex-col items-center justify-center space-y-2'}>
                              <img src={PercentCMSIcon} alt="PercentCMSIcon" className={'h-[165px] w-[212px]'} />
                              <span className={'text-sm text-[#818181]'}>Chưa có dữ liệu</span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className={'flex h-fit w-full flex-col xl:mt-[1rem]'}>
                        <h2 className={'mb-6 text-[22px] font-extrabold text-[#404040]'}>Top 5 sản phẩm của tôi</h2>
                        <div
                          className={
                            'flex flex-col space-y-[1px] rounded-l-[15px] rounded-tr-[15px] bg-white shadow-base'
                          }
                        >
                          {dataAccount && dataAccount.top5CreateByMe?.length > 0 ? (
                            dataAccount.top5CreateByMe.map((item: any, index: number) => (
                              <MyProductCard item={item} key={index} />
                            ))
                          ) : (
                            <div className={'flex h-fit w-full flex-col items-center justify-center space-y-2  py-10'}>
                              <img src={TopCMSIcon} alt="TopCMSIcon" className={'h-[165px] w-[212px]'} />
                              <span className={'text-sm text-[#818181]'}>Chưa có dữ liệu</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Scrollbars>
            {/* <ZaloChat /> */}
          </div>
        </div>
      )}
    </>
  );
};

const getName = (key: string) => {
  if (key === 'SIMSO') {
    return 'Sim số';
  } else if (key === 'GOICUOC') {
    return 'Gói cước';
  }
  return 'Vietlott';
};

const CustomLabel = ({ viewBox, value }: any) => {
  const { cx, cy } = viewBox;
  return (
    <text x={cx} y={cy} textAnchor="middle" dominantBaseline="central">
      <tspan fontSize="12" x={cx} y={cy - 20} fontWeight={500} color={'#818181'}>
        Tổng hoa hồng
      </tspan>
      <tspan fontSize="22" x={cx} y={cy} fontWeight={700} color={'#404040'}>
        {value}
      </tspan>
      <tspan fontSize="14" x={cx} y={cy + 20} fontWeight={800} color={'#404040'}>
        VNĐ
      </tspan>
    </text>
  );
};

const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="justify-ce relative flex h-fit w-fit flex-row items-center space-x-1.5 rounded-t-[18px] rounded-bl-[18px] bg-white px-8 py-1 shadow-[0_0_10px_rgba(255,233,220)]">
        <div className={'h-[24px] w-[24px]'}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_563_26637)">
              <path
                d="M12.2109 0.0507812C5.83275 0.0507812 0.65625 5.22728 0.65625 11.6055C0.65625 17.9837 5.83275 23.1602 12.2109 23.1602C18.5891 23.1602 23.7656 17.9837 23.7656 11.6055C23.7656 5.22728 18.5891 0.0507812 12.2109 0.0507812ZM13.8401 18.6423V20.8492H10.755V18.6192C8.77919 18.2032 7.10377 16.9322 6.97666 14.6906H9.24138C9.35693 15.9038 10.1889 16.8513 12.3034 16.8513C14.5681 16.8513 15.0765 15.7189 15.0765 15.0141C15.0765 14.0551 14.5681 13.1538 11.9914 12.5414C9.12584 11.8481 7.16154 10.6695 7.16154 8.30083C7.16154 6.31342 8.76764 5.0193 10.755 4.59177V2.36172H13.8401V4.61488C15.9893 5.13484 17.0639 6.76405 17.1332 8.53192H14.8685C14.8107 7.24935 14.129 6.37119 12.3034 6.37119C10.5702 6.37119 9.53025 7.15691 9.53025 8.26616C9.53025 9.23676 10.2813 9.87227 12.6154 10.4731C14.9494 11.074 17.4452 12.0792 17.4452 14.991C17.4337 17.1055 15.8507 18.261 13.8401 18.6423Z"
                fill="url(#paint0_linear_563_26637)"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_563_26637"
                x1="0.65625"
                y1="11.6055"
                x2="23.7656"
                y2="11.6055"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#F15836" />
                <stop offset="1" stopColor="#FF924F" />
              </linearGradient>
              <clipPath id="clip0_563_26637">
                <rect width="23.1094" height="23.1094" fill="white" transform="translate(0.65625 0.0507812)" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div className={'flex flex-col'}>
          <span className=" text-sm font-bold text-[#404040]">
            {get(payload, '[0].value', 0)?.toLocaleString('vi') || 0}
          </span>
          <span className=" text-[10px] font-normal leading-[20px] text-[#404040]">{label}</span>
        </div>
        <div className="absolute -bottom-4 left-1/3 inline-block w-16 overflow-hidden">
          <div className="h-4 w-4 origin-top-left -rotate-45 transform bg-white shadow-[0_0_10px_rgba(255,233,220)]"></div>
        </div>
      </div>
    );
  }

  return null;
};
